<template>
  <div class="ManageTeams">
    <admin-sidebar></admin-sidebar>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Admin/manage_teams.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <div class="text-center" id="welcome">
      Welcome @{{this.userName}}, Team: {{this.userTeam}}, Role: {{this.userRole}}
    </div>
    <b-modal id="show-bulk-assign-modal"
        title="Assign/Retract Events"
        @ok="bulkAssignEvent"
      >
      <div v-for="(numassigned, name) in numAssigned" :key="name">
        <b-progress :max="numassigned" class="mb-1" variant="warning">
          <b-progress-bar :value="numassigned">
            <strong style="color:black">{{name}}: {{numassigned}}/{{maxAssigned}}</strong>
          </b-progress-bar>
        </b-progress>
      </div>
      <b-form-group label="Select Events to Assign/Retract:">
        <b-form-select
        id="inline-form-input-name"
        v-model="assignTo"
        :options="teamMembers[userTeam]"
        @change="updateBulkAssignedEvents"
        @input="updateBulkAssignedEvents"
        size="sm"
        class="mr-1"
        required
        ></b-form-select>
        <b-form-radio-group
          id="radio-group-1"
          v-model="bulkAction"
          :options="assignOrRetract"
          name="radio-options"
        ></b-form-radio-group>
        <b-form-checkbox-group
          id="events-group-1"
          v-model="bulkEvents"
          v-if="bulkAction === 'Assign'"
          :options="bulkEventsToAssign"
          name="flavour-1"
        ></b-form-checkbox-group>
        <b-form-checkbox-group
          id="events-group-1"
          v-model="bulkEvents"
          v-if="bulkAction === 'Retract'"
          :options="bulkEventsAssigned"
          name="flavour-1"
        ></b-form-checkbox-group>
      </b-form-group>
    <div>{{ bulkAction }}: <strong>{{ bulkEvents }}</strong> to/from <strong>{{ assignTo }}</strong>?</div>
    </b-modal>
    <b-row>
      <b-col md="12">
        <b-tabs content-class="mt-3">
          <b-tab title="Team Members" active>
            <b-col md="4">
              <b-form-select
                    v-if="['SCIENCE PIPELINE EXPERT', 'PROJECT OFFICE', 'FRB COORDINATOR'].includes(userRole)"
                    id="myform"
                    v-model="userTeam"
                    :options="teams"
                    size="sm"
                    class="mr-1"
                    required
              ></b-form-select>
              <h5>Team {{userTeam}}</h5>
              <b-table show-empty
                :stacked="md"
                :items="teamItems[userTeam]"
                :fields="teamFields"
                :small="smallTable"
              >
              </b-table>
            </b-col>
          </b-tab>
          <b-tab title="Events ToDo" active>
            <b-col md="6" v-if="['SCIENCE PIPELINE EXPERT', 'PROJECT OFFICE', 'FRB COORDINATOR', 'TEAM LEADER'].includes(userRole)">
              <b-form-select
                    v-if="['SCIENCE PIPELINE EXPERT', 'PROJECT OFFICE', 'FRB COORDINATOR'].includes(userRole)"
                    id="myform"
                    v-model="userTeam"
                    :options="teams"
                    @input="getData('unsaved-events-for-analysis')"
                    size="sm"
                    class="mr-1"
                    required
              ></b-form-select>
              <div style="float:left" v-if="['SCIENCE PIPELINE EXPERT', 'PROJECT OFFICE', 'FRB COORDINATOR', 'TEAM LEADER'].includes(userRole)">
                <b-button size="sm" v-b-modal.show-bulk-assign-modal>Bulk Assign</b-button>
              </div>
              <b-table show-empty
                :responsive="sm"
                :items="unsavedEvents"
                :fields="eventFields"
                :small="smallTable"
              >
              <template v-slot:cell(actions)="row">
                <b-button size="sm"
                  @click.stop="assignEvent(row.item);"
                  class="mr-1">
                  Analyze
                </b-button>
                <b-button size="sm"
                  @click.stop="unassignEvent(row.item);"
                  class="mr-1">
                  Give Up
                </b-button>
                <div class="text-center" id="assigned"></div>
              </template>
              </b-table>
            </b-col>
            <b-col md="6" v-else>
              <b-table show-empty
                :responsive="sm"
                :items="unsavedEvents"
                :fields="eventFields"
                :small="smallTable"
              >
              <template v-slot:cell(actions)="row">
                <b-button size="sm"
                  @click.stop="assignEvent(row.item);"
                  class="mr-1">
                  Analyze
                </b-button>
                <b-button size="sm"
                  @click.stop="unassignEvent(row.item);"
                  class="mr-1">
                  Give Up
                </b-button>
              </template>
              </b-table>
            </b-col>
          </b-tab>
          <b-tab title="Flagged Events">
            <b-col md="6">
              <b-form-select
                    v-if="['SCIENCE PIPELINE EXPERT', 'PROJECT OFFICE', 'FRB COORDINATOR'].includes(userRole)"
                    id="myform"
                    v-model="userTeam"
                    :options="teams"
                    @input="getData('flagged-events-for-analysis')"
                    size="sm"
                    class="mr-1"
                    required
              ></b-form-select>
              <b-table show-empty
                :stacked="md"
                :items="flaggedEvents"
                :fields="eventFields"
                :small="smallTable"
              >
              <template v-slot:cell(actions)="row">
                <b-button size="sm"
                  @click.stop="assignEvent(row.item);"
                  class="mr-1">
                  Analyze
                </b-button>
                <b-button size="sm"
                  @click.stop="unassignEvent(row.item);"
                  class="mr-1">
                  Give Up
                </b-button>
              </template>
              </b-table>
            </b-col>
          </b-tab>
          <b-tab title="Saved Events">
            <b-col md="6">
              <b-form-select
                    v-if="['SCIENCE PIPELINE EXPERT', 'PROJECT OFFICE', 'FRB COORDINATOR'].includes(userRole)"
                    id="myform"
                    v-model="userTeam"
                    :options="teams"
                    @input="getData('saved-events-for-analysis')"
                    size="sm"
                    class="mr-1"
                    required
              ></b-form-select>
              <b-table show-empty
                :stacked="md"
                :items="savedEvents"
                :fields="eventFields"
                :small="smallTable"
              >
              </b-table>
            </b-col>
          </b-tab>
          <b-tab title="Bad Events">
            <b-col md="6">
              <b-form-select
                    v-if="['SCIENCE PIPELINE EXPERT', 'PROJECT OFFICE', 'FRB COORDINATOR'].includes(userRole)"
                    id="myform"
                    v-model="userTeam"
                    :options="teams"
                    @input="getData('bad-events-for-analysis')"
                    size="sm"
                    class="mr-1"
                    required
              ></b-form-select>
              <b-table show-empty
                :stacked="md"
                :items="badEvents"
                :fields="eventFields"
                :small="smallTable"
              >
              </b-table>
            </b-col>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import adminSidebar from './adminSidebar'
import { AdminMixin } from '../mixins/adminMixin.js'
export default {
  mixins: [AdminMixin],
  // mixins: [AuthVerificationMixin],
  data () {
    return {
      teamItems: {'1': [], '2': [], '3': [], '4': []},
      roleItems: {'projectOffice': [], 'frbCoordinator': [], 'teamLeaders': [], 'systempipelineExperts': [], 'members': [], 'sciencepipelineExperts': [], 'dataqualityExperts': [], 'systemTsars': []},
      teamFields: [],
      roleFields: [],
      eventFields: [
        {key: 'event_id', sortable: true, label: 'Event Id', 'class': 'text-left'},
        {key: 'assigned_users', sortable: true, label: 'Assigned To', 'class': 'text-left'},
        {key: 'actions', sortable: false, label: 'Actions', 'class': 'text-left'}
      ],
      unsavedEvents: [],
      savedEvents: [],
      flaggedEvents: [],
      badEvents: [],
      teamMembers: {
        '1': [{ text: 'Select One', value: null }],
        '2': [{ text: 'Select One', value: null }],
        '3': [{ text: 'Select One', value: null }],
        '4': [{ text: 'Select One', value: null }]
      },
      userRole: 'MEMBER',
      userTeam: '',
      userName: '',
      assignTo: '',
      retractFrom: '',
      bulkEventsToAssign: [],
      bulkEvents: [],
      bulkAction: '',
      numAssigned: {},
      maxAssigned: 0,
      assignOrRetract: ['Assign', 'Retract'],
      form: {
        name: '',
        team: null,
        role: null,
        options: [{ value: null, text: 'Please select an option' }],
        checked: []
      },
      teams: [{ text: 'Select One', value: null }, '1', '2', '3', '4'],
      roles: [{ text: 'Select One', value: null }, 'PROJECT OFFICE', 'FRB COORDINATOR', 'SYSTEM PIPELINE EXPERT', 'FRB ADMIN', 'SCIENCE PIPELINE EXPERT', 'TEAM LEADER', 'MEMBER', 'DATA QUALITY EXPERT', 'SYSTEM TSAR'],
      submitStatus: null,
      baseUrl: 'https://frb.chimenet.ca/frb-master/'
    }
  },
  mounted () {
    this.refreshToken()
    this.userName = localStorage.username
    var authHeaders = {'Authorization': localStorage.accessToken}
    this.$http.get(this.baseUrl + '/v1/admin/role/' + localStorage.username, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
      .then(response => {
        this.getTeamUserRole(response.body)
        this.$http.get(this.baseUrl + '/v1/admin/team/' + localStorage.username, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
          .then(response => {
            this.userTeam = response.body
            this.fetchAll()
          })
      })
  },
  methods: {
    fetchAll () {
      this.getDelayedData()
      this.getUsers()
      this.getAnalysisEvents()
    },
    getTeamUserRole (roles) {
      this.userRoles = roles
      var scienceRoles = ['MEMBER', 'TEAM LEADER', 'DATA QUALITY EXPERT', 'SCIENCE PIPELINE EXPERT']
      var higherRoles = ['PROJECT OFFICE', 'FRB COORDINATOR']
      this.userRole = 'MEMBER'
      for (var r = 0; r < roles.length; r++) {
        if (scienceRoles.includes(roles[r])) {
          this.userRole = roles[r]
        } else if (higherRoles.includes(roles[r])) {
          this.userRole = roles[r]
        }
      }
    },
    getDelayedData () {
      var myTimerPromise = this.waitForIt(3000)
      Promise.all([myTimerPromise]).then(() => {
        this.bulkEventsToAssign = []
        this.bulkEventsAssigned = []
        this.maxAssigned = 0
        this.numAssigned = {}
        for (var i = 0; i < this.teamMembers[this.userTeam].length; i++) {
          this.numAssigned[this.teamMembers[this.userTeam][i]] = 0
        }
        this.fetchEvents('unsaved-events-for-analysis', this.userTeam)
        this.fetchEvents('saved-events-for-analysis', this.userTeam)
        this.fetchEvents('flagged-events-for-analysis', this.userTeam)
        this.fetchEvents('bad-events-for-analysis', this.userTeam)
      })
    },
    getData (fetch) {
      this.refreshToken()
      this.maxAssigned = 0
      this.numAssigned = {}
      for (var i = 0; i < this.teamMembers[this.userTeam].length; i++) {
        this.numAssigned[this.teamMembers[this.userTeam][i]] = 0
      }
      this.bulkEventsToAssign = []
      this.bulkEventsAssigned = []
      this.fetchEvents(fetch, this.userTeam)
    },
    waitForIt (waitTime) {
      // Create a new Promise and resolve after 2 seconds
      var waitPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, waitTime)
      })
      return waitPromise
    },
    fetchEvents (urlExtension, team) {
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(this.baseUrl + '/v1/analysis/' + urlExtension + '/' + team, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseEvents(response.body, urlExtension)
        }, response => {
        })
    },
    parseEvents (events, eventType) {
      this.maxAssigned += events.length
      if (eventType === 'unsaved-events-for-analysis') {
        this.unsavedEvents = []
      }
      if (eventType === 'saved-events-for-analysis') {
        this.savedEvents = []
      }
      if (eventType === 'flagged-events-for-analysis') {
        this.flaggedEvents = []
      }
      if (eventType === 'bad-events-for-analysis') {
        this.badEvents = []
      }
      for (var i = 0; i < events.length; i++) {
        var item = {}
        item['event_id'] = events[i]['candidate_id']
        item['assigned_users'] = ''
        for (var j = 0; j < events[i]['users'].length; j++) {
          if (events[i]['users'][j] !== 'null') {
            if (this.teamMembers[this.userTeam].includes(events[i]['users'][j])) {
              this.numAssigned[events[i]['users'][j]] += 1
            }
            if (j === 0) {
              item['assigned_users'] = item['assigned_users'] + events[i]['users'][j]
            } else {
              item['assigned_users'] = item['assigned_users'] + ', ' + events[i]['users'][j]
            }
          }
        }
        if (item['assigned_users'] === '') {
          if (!this.bulkEventsToAssign.includes(parseInt(item['event_id']))) {
            this.bulkEventsToAssign.push(item['event_id'])
          }
        } else {
          this.bulkEventsAssigned.push(item['event_id'])
        }
        if (eventType === 'unsaved-events-for-analysis') {
          item['_rowVariant'] = 'danger'
          if (!this.inList(item, this.unsavedEvents)) {
            this.unsavedEvents.push(item)
          }
        }
        if (eventType === 'saved-events-for-analysis') {
          item['_rowVariant'] = 'success'
          if (!this.inList(item, this.savedEvents)) {
            this.savedEvents.push(item)
          }
        }
        if (eventType === 'flagged-events-for-analysis') {
          item['_rowVariant'] = 'warning'
          if (!this.inList(item, this.flaggedEvents)) {
            this.flaggedEvents.push(item)
          }
        }
        if (eventType === 'bad-events-for-analysis') {
          item['_rowVariant'] = 'info'
          if (!this.inList(item, this.badEvents)) {
            this.badEvents.push(item)
          }
        }
      }
    },
    inList (obj, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (parseInt(obj['event_id']) === parseInt(arr[i]['event_id'])) {
          return true
        }
      }
      return false
    },
    updateBulkAssignedEvents () {
      if (this.bulkAction === 'Retract') {
        this.bulkEvents = []
        this.bulkEventsAssigned = []
        for (var i = 0; i < this.unsavedEvents.length; i++) {
          var item = this.unsavedEvents[i]
          if (item['assigned_users'].includes(this.assignTo)) {
            this.bulkEventsAssigned.push(item['event_id'])
          }
        }
        for (i = 0; i < this.savedEvents.length; i++) {
          item = this.savedEvents[i]
          if (item['assigned_users'].includes(this.assignTo)) {
            this.bulkEventsAssigned.push(item['event_id'])
          }
        }
        for (i = 0; i < this.flaggedEvents.length; i++) {
          item = this.flaggedEvents[i]
          if (item['assigned_users'].includes(this.assignTo)) {
            this.bulkEventsAssigned.push(item['event_id'])
          }
        }
        for (i = 0; i < this.badEvents.length; i++) {
          item = this.badEvents[i]
          if (item['assigned_users'].includes(this.assignTo)) {
            this.bulkEventsAssigned.push(item['event_id'])
          }
        }
      }
    },
    parseTeams (users) {
      if (!this.teamMembers[1].includes(null)) {
        this.teamMembers[1].push(null)
      }
      if (!this.teamMembers[2].includes(null)) {
        this.teamMembers[2].push(null)
      }
      if (!this.teamMembers[3].includes(null)) {
        this.teamMembers[3].push(null)
      }
      if (!this.teamMembers[4].includes(null)) {
        this.teamMembers[4].push(null)
      }
      for (var i = 0; i < users.length; i++) {
        var item = {}
        if (users[i]['team'] === '1') {
          item['_rowVariant'] = 'danger'
        } else if (users[i]['team'] === '2') {
          item['_rowVariant'] = 'success'
        } else if (users[i]['team'] === '4') {
          item['_rowVariant'] = 'warning'
        } else {
          item['_rowVariant'] = 'info'
        }
        item['name'] = users[i]['name']
        item['roles'] = users[i]['roles']
        if (!this.teamMembers[users[i]['team']].includes(item['name'])) {
          this.teamMembers[users[i]['team']].push(item['name'])
          this.teamItems[users[i]['team']].push(item)
        }
      }
    },
    assignEvent (evItem) {
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(this.baseUrl + '/v1/analysis/assign/' + evItem['event_id'] + '/' + localStorage.username, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          // document.getElementById('assigned').innerHTML = 'Successfully added'
          alert('Successfully added')
        }, response => {
          // document.getElementById('assigned').innerHTML = 'Failed to be added'
          alert('Failed to be added')
        })
    },
    unassignEvent (evItem) {
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(this.baseUrl + '/v1/analysis/retract/' + evItem['event_id'] + '/' + localStorage.username, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          // document.getElementById('assigned').innerHTML = 'Successfully retracted'
          alert('Successfully retracted')
        }, response => {
          // document.getElementById('assigned').innerHTML = 'Failed to retract'
          alert('Failed to retract')
        })
    },
    assignEventTo (evItem) {
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      if (this.assignTo !== 'null') {
        this.$http.post(this.baseUrl + '/v1/analysis/assign/' + evItem['event_id'] + '/' + this.assignTo, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
          .then(response => {
            this.assignTo = ''
            this.fetchAll()
          }, response => {
            // document.getElementById('assigned' + evItem['event_id']).innerHTML = 'Failed to be added'
            alert('Failed to be added')
          })
      }
    },
    retractEventFrom (evItem) {
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      if (this.retractFrom !== 'null') {
        this.$http.post(this.baseUrl + '/v1/analysis/retract/' + evItem['event_id'] + '/' + this.retractFrom, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
          .then(response => {
            alert('Successfully retracted')
          }, response => {
            alert('Failed to retract')
          })
      }
      this.retractFrom = ''
    },
    bulkAssignEvent (evt) {
      if (this.bulkEvents === []) {
        alert('ERROR: You need to select at least one event number.')
        return false
      }
      if (this.assignTo === '') {
        alert('ERROR: You need to select a member to assign events to.')
        return false
      }
      if (this.bulkAction === 'Assign') {
        this.refreshToken()
        var authHeaders = {'Authorization': localStorage.accessToken}
        this.$http.post(this.baseUrl + '/v1/analysis/assign/' + this.assignTo, this.bulkEvents, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
          .then(response => {
            // document.getElementById('assigned').innerHTML = 'Successfully added'
            alert('Successfully added')
            this.bulkEvents = []
            this.fetchAll()
          }, response => {
            alert(response.body)
            // document.getElementById('assigned').innerHTML = 'Failed to be added'
            alert('Failed to be added')
          })
        return false
      } else if (this.bulkAction === 'Retract') {
        this.refreshToken()
        authHeaders = {'Authorization': localStorage.accessToken}
        this.$http.post(this.baseUrl + '/v1/analysis/retract/' + this.assignTo, this.bulkEvents, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
          .then(response => {
            // document.getElementById('assigned').innerHTML = 'Successfully retracted'
            alert('Successfully retracted')
            this.bulkEvents = []
            this.fetchAll()
          }, response => {
            // document.getElementById('assigned').innerHTML = 'Failed to be retracted'
            alert('Failed to be retracted')
          })
        return false
      } else {
        alert('ERROR: You need to select one of Assign or Retract options.')
        return false
      }
    }
  },
  components: {
    'admin-sidebar': adminSidebar
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Admin/manage_teams.vue